module.exports = __webpack_public_path__ + "img/9.cc3301f6.png";